import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Question: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_28377)'>
        <path
          d='M6.59478 23C5.83639 23 5.31992 22.848 5.30642 22.8439C5.12135 22.8087 4.92393 22.6697 4.80718 22.4733C4.55263 22.1072 4.65321 21.5634 5.04719 21.2855C5.76615 20.765 6.31219 20.0227 6.6698 19.0775C4.14047 17.1864 2.64062 14.1975 2.64062 11.015C2.64072 5.49263 7.09087 1 12.5608 1C18.0307 1 22.4809 5.49263 22.4809 11.015C22.4809 16.5372 18.0307 21.0299 12.5608 21.0299C12.0087 21.0299 11.4375 20.9796 10.822 20.8759C9.46891 22.6469 7.75088 23 6.59478 23ZM12.5608 1.87715C7.57461 1.87715 3.51787 5.97638 3.51787 11.015C3.51787 14.023 4.98556 16.8411 7.44331 18.5535C7.6015 18.6639 7.66935 18.865 7.60982 19.0486C7.19967 20.3182 6.50923 21.311 5.55734 22.0001C5.67753 22.0373 8.40037 22.8196 10.2698 20.1445C10.3688 20.0036 10.5398 19.932 10.7116 19.9646C11.3778 20.0911 11.9827 20.1528 12.5608 20.1528C17.547 20.1528 21.6037 16.0536 21.6037 11.015C21.6037 5.97628 17.5471 1.87715 12.5608 1.87715Z'
          fill='url(#paint0_linear_12280_28377)'
          stroke='url(#paint1_linear_12280_28377)'
          strokeWidth='0.5'
        />
        <path
          d='M12.1859 17.8682C11.5156 17.8682 10.9681 17.6561 10.5119 17.2202C10.0603 16.7645 9.83594 16.2015 9.83594 15.5379C9.83594 14.8986 10.0579 14.3383 10.4954 13.8721C10.9682 13.4191 11.5156 13.207 12.186 13.207C12.8714 13.207 13.438 13.4279 13.8693 13.8638C14.3121 14.3107 14.5365 14.8742 14.5365 15.5378C14.5365 16.2247 14.3095 16.7908 13.8605 17.2201C13.4379 17.6473 12.8713 17.8682 12.1859 17.8682ZM12.1859 14.0841C11.7468 14.0841 11.4073 14.2132 11.1185 14.4895C10.8515 14.7751 10.713 15.1236 10.713 15.5378C10.713 15.9676 10.8484 16.3134 11.1268 16.5938C11.4073 16.8618 11.7468 16.9908 12.1859 16.9908C12.6349 16.9908 12.9812 16.8608 13.245 16.5943C13.5302 16.3211 13.6592 15.9882 13.6592 15.5377C13.6592 15.1016 13.5275 14.7657 13.2455 14.4811C12.9812 14.2143 12.6349 14.0841 12.1859 14.0841Z'
          fill='url(#paint2_linear_12280_28377)'
          stroke='url(#paint3_linear_12280_28377)'
          strokeWidth='0.5'
        />
        <path
          d='M13.8502 12.7012H10.5287C10.2865 12.7012 10.0901 12.5047 10.0901 12.2627V10.8588C10.0901 10.0713 10.2394 9.49941 10.5603 9.05931C10.8558 8.62274 11.3572 8.2635 12.085 7.97364C12.3991 7.8565 12.6059 7.74655 12.7076 7.64339C12.7791 7.57908 12.8129 7.52884 12.8129 7.42559C12.8129 7.29343 12.7714 7.24577 12.7294 7.20893C12.7202 7.20319 12.6098 7.14261 12.3246 7.14261C11.9094 7.14261 11.7719 7.28108 11.759 7.71181C11.7522 7.94933 11.5579 8.13747 11.3204 8.13747H8.13416C8.0155 8.13747 7.90143 8.08924 7.81894 8.00426C7.73597 7.9188 7.69138 7.8032 7.69559 7.68444C7.73817 6.41274 8.19072 5.38832 9.04193 4.63921C9.90874 3.91651 11.0492 3.55469 12.4408 3.55469C13.3713 3.55469 14.1573 3.70809 14.8446 4.02388C15.556 4.33748 16.1133 4.79165 16.4953 5.3708C16.8877 5.94307 17.0889 6.63007 17.0889 7.40654C17.0889 8.08158 16.9142 8.68245 16.5699 9.19299C16.2386 9.68295 15.7374 10.0878 15.0795 10.3973C14.7933 10.5197 14.5563 10.6737 14.4309 10.8167C14.3324 10.9271 14.2889 11.036 14.2889 11.1707V12.2626C14.2887 12.5048 14.0923 12.7012 13.8502 12.7012ZM10.9672 11.8241H13.4116V11.1708C13.4116 10.8194 13.5335 10.5047 13.7734 10.2351C13.986 9.99358 14.323 9.76592 14.7206 9.59635C15.2189 9.36199 15.6009 9.05883 15.8426 8.70159C16.0909 8.33403 16.2117 7.91 16.2117 7.40645C16.2117 6.81083 16.0619 6.29035 15.7669 5.86057C15.475 5.41779 15.0446 5.07147 14.4838 4.82371C13.9083 4.5593 13.2416 4.43184 12.4407 4.43184C11.243 4.43184 10.3181 4.71797 9.61266 5.30535C9.05064 5.80048 8.71838 6.44442 8.60948 7.26032H10.9377C11.0974 6.62222 11.5852 6.26546 12.3245 6.26546C12.7356 6.26546 13.0498 6.35207 13.2846 6.53035C13.5625 6.77351 13.69 7.06797 13.69 7.42568C13.69 7.76578 13.5589 8.06177 13.31 8.28168C13.1312 8.4636 12.8439 8.62733 12.4007 8.79279C11.8584 9.00897 11.4778 9.26917 11.2782 9.56429C11.0661 9.85511 10.9671 10.2745 10.9671 10.8588V11.8241H10.9672Z'
          fill='url(#paint4_linear_12280_28377)'
          stroke='url(#paint5_linear_12280_28377)'
          strokeWidth='0.5'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_28377'
          x1='6.74908'
          y1='2.50015'
          x2='17.3796'
          y2='21.715'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_28377'
          x1='6.74908'
          y1='2.50015'
          x2='17.3796'
          y2='21.715'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_28377'
          x1='10.8093'
          y1='13.5249'
          x2='12.9227'
          y2='17.7964'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_28377'
          x1='10.8093'
          y1='13.5249'
          x2='12.9227'
          y2='17.7964'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_28377'
          x1='9.64051'
          y1='4.17838'
          x2='13.7414'
          y2='12.6198'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_28377'
          x1='9.64051'
          y1='4.17838'
          x2='13.7414'
          y2='12.6198'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_28377'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Question;
